import * as React from "react";
import type { SVGProps } from "react";
const SvgPackageCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m19.67 7.2-8.313-4.8-8.314 4.8v9.6l8.314 4.8M19.67 7.2l-8.314 5.4m8.314-5.4V12m-8.314 9.6v-9m0 9 1.8-1.039m-1.8-7.961-7.8-4.8m11.4 1.8-7.8-4.8m9 13.2 1.2 1.2 3.6-3.6"
    />
  </svg>
);
export default SvgPackageCheck;
